export const counters = [
    {
        number: 459,
        name: "Projects"
    },
    {
        number: 241,
        name: "Clients"
    },
    {
        number: 56,
        name: "Countries"
    },
    {
        number: 15,
        name: "Awards"
    },

]